import React from "react";
import { rackSignFontSizeMm } from "../../../functions/shelfLabels";

/**
 * Stellingbordjes: one A4 per stelling (functions/shelfLabels buildRackSigns), the number as big
 * as the page allows, for the head of the rack where a picker coming down the aisle sees it. No
 * barcode: nothing on a sign is to be scanned, and a scanned sign would only confuse the app.
 * Printed with `@page { size: A4; margin: 0 }` (SHELF_LABEL_PAGE_STYLE); laminated in the freezer.
 *
 * @param {Array} signs - `{ rack, first, last, count, zones }`
 */
const RackSignSheet = React.forwardRef(({ signs }, ref) => (
  <div ref={ref}>
    {(signs || []).map((sign, index) => (
      <div
        key={sign.rack}
        data-rack={sign.rack}
        style={{
          width: "210mm",
          height: "297mm",
          boxSizing: "border-box",
          padding: "18mm 10mm",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Arial, Helvetica, sans-serif",
          color: "#000",
          background: "#fff",
          overflow: "hidden",
          pageBreakAfter: index < signs.length - 1 ? "always" : "auto",
          breakAfter: index < signs.length - 1 ? "page" : "auto",
        }}
      >
        <div style={{ fontSize: "16mm", fontWeight: 700, letterSpacing: "4mm" }}>STELLING</div>
        <div style={{ fontSize: `${rackSignFontSizeMm(sign.rack)}mm`, fontWeight: 900, lineHeight: 1 }}>{sign.rack}</div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "12mm", fontWeight: 700 }}>
            {sign.count > 1 ? `vakken ${sign.first} t/m ${sign.last}` : `vak ${sign.first}`}
          </div>
          {sign.zones.length > 0 && <div style={{ fontSize: "9mm", marginTop: "4mm" }}>{sign.zones.join(" · ")}</div>}
        </div>
      </div>
    ))}
  </div>
));

export default RackSignSheet;
